import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'

const trainerCapabilityFields = {
  capability: true,
  granted: true,
  dependsOn: true,
} as const

export const GQL_TRAINER_CAPABILITIES = typedGql('query')({
  trainerCapabilities: trainerCapabilityFields,
})

export const GQL_UPDATE_TRAINER_CAPABILITIES = typedGql('mutation')({
  updateTrainerCapabilities: [
    { grants: $('grants', '[TrainerCapabilityGrantInput!]!') },
    trainerCapabilityFields,
  ],
})
